import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { RovoDevAgentsLogo } from "@/components/signup/utils/get-rovo-dev-agents-logo";

import { GetStartedHeading } from "../../../components";

export const LoggedOutDevAIFree = () => {
    return (
        <SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
            <GetStartedHeading productName="Rovo Dev Agents" />
            <AccountCreation />
        </SignupBackgroundLayout>
    );
};
